import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import MentorFormationActions from './mentor-formation';
import MentorshipActions from './Mentorship';

const AdminRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MentorshipActions />} />
      <Route path="/mentor-formation" element={<MentorFormationActions />} />
    </Routes>
  );
};

export default AdminRoutes;
